// src/icons/Logout.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function Logout() {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.2917 1.125H14.0417C14.5019 1.125 14.875 1.4981 14.875 1.95833V14.0417C14.875 14.5019 14.5019 14.875 14.0417 14.875H10.2917M10.5 8H1.125M10.5 8L7.58333 10.9167M10.5 8L7.58333 5.08333",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}

export {
  Logout
};
